module.exports = __webpack_public_path__ + "img/lrc-home@2x.ce99570c.png";